require('../scss/app.scss');

require('./genplan/index');
require('./col-configurator/index');
require('./map/map');
require('./uploader-required-fix/fix');
require('./files-field/filesField');